<template>
  <div class="page">
    <h3 class="text-h3">Setup</h3>
    <p class="text-body-1 mt-2">
      In order to use our DeepPath platform you need to install two different
      software packages. Follow the guides below.
    </p>
    <h4 class="text-h4 mt-3">DICOM Server</h4>
    <p class="text-body-1 mt-2">
      The DICOM server is necessary to make contributed slides available to
      other users. It is available as an all-included docker image. Please have
      <a href="https://docs.docker.com/get-docker/" target="_blank">Docker</a>
      and
      <a href="https://docs.docker.com/compose/install/" target="_blank"
        >docker-compose</a
      >
      installed (latest versions). Execute the following code to run the DICOM
      server:
    </p>
    <p>
      <code
        >curl http://......../docker-compose.yml >> docker-compose.yml &&
        docker-compose up -d</code
      >
    </p>
    <h4 class="text-h4 mt-3">ROI Extractor</h4>
    <p class="text-body-1 mt-2">
      The ROI Extractor is used to extract annotations from your slides.
    </p>
    <p>
      <code
        >curl http://......../docker-compose.yml >> docker-compose.yml &&
        docker-compose up -d
      </code>
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
